import React, { useState } from "react";
import classnames from "classnames";

const TableFilter = ({
  mapping,
  id,
  containerClassName,
  style,
  initialActive,
  buttonClassName
}) => {
  const [active, setActive] = useState(initialActive);
  const buttons = Object.keys(mapping)
    .map(key => {
      const elementClass = `cursor-pointer px-2 ${
        (active || "").toLowerCase() === (key || "").toLowerCase()
          ? "text-green-primary"
          : ""
      }`;
      return (
        <button
          type="button"
          key={key}
          onClick={e => {
            setActive(key);
            mapping[key].fn();
          }}
          className={classnames("outline-0-important", buttonClassName)}
        >
          {mapping[key].Component ? (
            mapping[key].Component({ elementClass })
          ) : (
            <span className={elementClass}>{mapping[key].name}</span>
          )}
        </button>
      );
    })
    .reduce((acc, x) => (acc == null ? [x] : [acc, "|", x]));

  return (
    <div id={id} className={containerClassName} style={style}>
      {buttons}
    </div>
  );
};

export default TableFilter;
